/** Per-project ingest keys and the sourcemap upload screen. */
const en = {
  /** The org-level page: server tokens and the assistants connected over MCP. */
  access: {
    title: 'API & MCP access',
    subtitle:
      'Programmatic access to this organization. A server token is not tied to a project: it carries the organization and a role, and an assistant connected over MCP reads every project you can see.',
    movedFrom:
      'Server tokens and MCP used to sit here, which read as though they belonged to a project. They never did; they belong to the organization and now live under',
    ingestPointer: 'Looking for a project’s SDK ingest key? That one is per-project, under',
    ingestPointerLink: 'Projects',
  },
  apiKeys: {
    title: 'API Keys',
    revealed: 'Your ingest key (public, safe to embed):',
    copied: 'Copied ✓',
    copy: 'Copy',
    keyName: 'Key name',
    createKey: 'Create key',
    showRevoked: (n: number) => `Show revoked (${n})`,
    columns: {
      name: 'Name',
      prefix: 'Prefix',
      lastUsed: 'Last used',
      status: 'Status',
      actions: 'Actions',
    },
    never: 'never',
    revoked: 'revoked',
    active: 'active',
    revoke: 'Revoke',
  },
  sourcemaps: {
    title: 'Sourcemaps',
    subtitle: 'Upload build sourcemaps so minified error stacks resolve to your original source.',
    project: 'Project',
    release: 'Release version',
    releasePlaceholder: 'e.g. 1.4.2 or a commit sha',
    releaseHelp:
      'Must match the release your SDK reports, so a session’s errors find the right maps.',
    upload: 'Upload symbol files',
    uploadFailed: (reason: string) => `Upload failed: ${reason}`,
    columns: { file: 'File', release: 'Release', size: 'Size', uploaded: 'Uploaded' },
    android: 'Android',
    empty:
      'No symbol files yet. Upload your web build’s .map files (e.g. from dist/assets), or an Android release’s mapping.txt (from build/outputs/mapping/release/), tagged with the matching release version.',
  },
};

const tr: typeof en = {
  access: {
    title: 'API ve MCP erişimi',
    subtitle:
      'Bu şirkete programatik erişim. Sunucu belirteci bir projeye bağlı değildir: şirketi ve bir rolü taşır, MCP ile bağlanan bir asistan da görebildiğiniz bütün projeleri okur.',
    movedFrom:
      'Sunucu belirteçleri ve MCP eskiden buradaydı; sanki bir projeye aitmiş gibi duruyordu. Hiçbir zaman öyle değildi. Artık şirkete ait ve şuraya taşındı:',
    ingestPointer: 'Bir projenin SDK ingest anahtarını mı arıyorsunuz? O projeye özeldir, şurada:',
    ingestPointerLink: 'Projeler',
  },
  apiKeys: {
    title: 'API Anahtarları',
    revealed: 'Veri alım anahtarınız (herkese açık, gömmesi güvenli):',
    copied: 'Kopyalandı ✓',
    copy: 'Kopyala',
    keyName: 'Anahtar adı',
    createKey: 'Anahtar oluştur',
    showRevoked: (n: number) => `İptal edilenleri göster (${n})`,
    columns: {
      name: 'Ad',
      prefix: 'Ön ek',
      lastUsed: 'Son kullanım',
      status: 'Durum',
      actions: 'İşlemler',
    },
    never: 'hiç',
    revoked: 'iptal edildi',
    active: 'etkin',
    revoke: 'İptal et',
  },
  sourcemaps: {
    title: 'Kaynak Haritaları',
    subtitle:
      'Küçültülmüş hata yığınlarının özgün kaynağınıza çözülmesi için derleme kaynak haritalarını yükleyin.',
    project: 'Proje',
    release: 'Sürüm numarası',
    releasePlaceholder: 'örn. 1.4.2 ya da bir commit sha',
    releaseHelp:
      'SDK’nızın bildirdiği sürümle eşleşmeli ki bir oturumun hataları doğru haritaları bulsun.',
    upload: 'Sembol dosyalarını yükle',
    uploadFailed: (reason: string) => `Yükleme başarısız: ${reason}`,
    columns: { file: 'Dosya', release: 'Sürüm', size: 'Boyut', uploaded: 'Yüklenme' },
    android: 'Android',
    empty:
      'Henüz sembol dosyası yok. Web derlemenizin .map dosyalarını (örn. dist/assets içinden) ya da bir Android sürümünün mapping.txt dosyasını (build/outputs/mapping/release/ içinden) eşleşen sürüm numarasıyla etiketleyerek yükleyin.',
  },
};

export const keys = { en, tr };
